/**
 * Get solar route in context of a single storage installation, or in the context of a farm when a client is selected
 *
 * @param installationId
 * @param storageId
 * @param pviIndex
 * @param url
 * @returns
 */
export const getDetailsRoute = (
  installationId = ':installationId',
  storageId = ':storageId',
  pviIndex: string | number = ':pviIndex',
  url?: string
): string => {
  if (url) {
    return `${url}/properties/solar/${pviIndex}`
  }

  return `/installation/${installationId}/${storageId}/properties/solar/${pviIndex}`
}

/**
 * Get solar route in the context of a farm, if server is selected.
 *
 * @param installationId
 * @param storageId
 * @param clientStorageId
 * @param pviIndex
 * @param url
 * @returns
 */
export const getFarmDetailsRoute = (
  installationId = ':installationId',
  storageId = ':storageId',
  clientStorageId = ':clientStorageId',
  pviIndex: string | number = ':pviIndex',
  url?: string
): string => {
  if (url) {
    return `${url}/properties/solar`
  }

  return `/installation/${installationId}/${storageId}/properties/solar/${clientStorageId}/${pviIndex}`
}

/**
 * Get solar route base route
 *
 * @param installationId
 * @param storageId
 * @param url
 * @returns
 */
export const getBaseRoute = (
  installationId: string | number = ':installationId',
  storageId: string | number = ':storageId',
  url?: string
): string => {
  if (url) {
    return `${url}/properties/solar`
  }

  return `/installation/${installationId}/${storageId}/properties/solar`
}
